import React, { useEffect, useState } from "react";
import axios from "../../axios";
import * as url from "../../utils/url";
import Plot from "./../../utils/customPlotly";
import moment from "moment";

function MetricsPieChart({ planning }) {
  const [pieData, setPiedata] = useState(null);

  useEffect(() => {
    if (planning.total.current >= 0) {
      const values = [planning.incomplete.current, 0, 0];

      const labels = ["Incomplete", "Completed", "In Progress"];

      const type = "pie";

      const pie_colors = [
        "rgb(233 236 239)",
        "rgb(40 167 69)",
        "rgb(80 153 222)",
      ];

      const data = {
        values,
        labels,
        // pull: [0.2, 0, 0],
        type,
        marker: { colors: pie_colors },
        hoverinfo: "label+percent",
        textinfo: "label+percent",
        texttemplate: "<b> %{label} </b> <br>" + "%{value} (%{percent})",
        textposition: "outside",
        // insidetextorientation: "radial",
        textfont: {
          // 'family': "Times",
          // 'size': 16,
          // 'color': ["IndianRed", "MediumPurple", "DarkOrange"]
        },
      };

      setPiedata(data);
    }
  }, [planning]);

  if (pieData) {
    console.log(pieData);
    return (
      <div className="profile-metrics-plot">
        <Plot
          data={[pieData]}
          layout={{
            showlegend: false,
            height:300,
            // width:400,
            automargin: true,
            margin: { t: 40, b: 30, l: 80, r: 80, pad: 0 },
          }}
          scrollZoom={true}
          config={{
            scrollZoom: true,
            modeBarButtonsToAdd: [
              "drawline",
              "drawopenpath",
              "drawclosedpath",
              "drawcircle",
              "drawrect",
              "eraseshape",
            ],
            displaylogo: false,
            responsive: true,
            toImageButtonOptions: {
              format: "png",
              filename: `Pie Chart - ${moment(new Date()).format("MM-D-YYYY")}`,
              height: 600,
              width: null,
              scale: 1,
            },
          }}
          className="plotlyChart"
        />
      </div>
    );
  } else {
    return <div className="text-center">No stats to show</div>;
  }
}

export default MetricsPieChart;
